/**
 * @param {*} obj
 * @param {Function} classType
 */
function isAssignableTo (obj, classType) {
  if (obj instanceof classType) {
    return true
  }
    
  // Additional validations for properties and methods of the class
  if (typeof obj !== 'object' || obj === null) {
    return false
  }
    
  const classProperties = Object.getOwnPropertyNames(classType.prototype)
    
  for (const property of classProperties) {
    const classProperty = classType.prototype[property]
    
    if (typeof classProperty === 'function') {
      // Check if the property is a method
      if (typeof obj[property] !== 'function') {
        return false
      }
    } else {
      // Check if the property is an attribute
      if (typeof obj[property] === 'undefined') {
        return false
      }
    }
  }
    
  return true
}

export { isAssignableTo }
